<template>
  <div>
    <h2>Search</h2>
    <Unclaimed />
  </div>
</template>

<script>
import Unclaimed from "@/components/layout/widgets/ReceiptsUnclaimed";
export default {
  name: "ReceiptsUnclaimed",
  metaInfo() {
    return {
      title: "Receipts unclaimed",
      titleTemplate: "%s - Fundview - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true,
      },
    };
  },
  components: {
    Unclaimed,
  },
};
</script>